<div class="menu-icon" *ngIf="showMobile && isClientVisible">
    <div class="logo-container" id="top">
        <img alt="HSABank" src="../../../assets/imgs/hsab-logo.png" />
    </div>
    <div *ngIf="showMenu" class="modal-close" (click)="expandMenu()">
        <img alt="Close" src="../../../assets/icons/circle-x.svg" />
    </div>
    <mat-icon *ngIf="!showMenu" (click)="expandMenu()">menu</mat-icon>
</div>
<div class="slider-container" id="slider-container" [style.height.px]="myInnerHeight" *ngIf="(showMobile) ? showMenu && isClientVisible : isClientVisible" [ngStyle]="{ 'display': (showMobile && !showMenu) ? 'none' : 'flex', 'z-index' : (showMobile && !showMenu) ? 'unset' : '98' }">
<!--     <div class="menu-icon" *ngIf="showMobile && isClientVisible">
        <mat-icon (click)="expandMenu()">menu</mat-icon>
    </div> -->
    <div class="main-container" id="main-container" [style.height.px]="myInnerHeight" *ngIf="(showMobile) ? showMenu && isClientVisible : isClientVisible">
        <div class="section" *ngIf="isClientVisible">
            <div class="section-header">
                <img alt="My information" class="page-icon" src="../../../assets/icons/my info.svg" />
                <span>My information</span>
                <span (click)="directUserToForm('my-information')" (keyup.enter)="directUserToForm('my-information')" class="edit-icon" tabindex=0>
                    <mat-icon>edit</mat-icon>
                </span>
            </div>
            <div class="section-content">
                <div>
                    <span>Age: <b>{{client.currentAge}}</b></span>
                    <span>Sex: <b>{{formatGender(clientGenderStr)}}</b></span>
                </div>
                <p><b>{{maritalStatus}}</b></p>
                <div>
                    <p>Household income: <b *ngIf="client.annualIncome + client.spouseAnnualIncome < 100000">{{client.annualIncome + client.spouseAnnualIncome | currency : 'USD' : 'symbol' : '1.0-0'}}</b><b *ngIf="client.annualIncome + client.spouseAnnualIncome >= 100000">${{ kFormatter(client.annualIncome + client.spouseAnnualIncome) }}</b></p>
                    <p>State of Residency: <b>{{client.retirementState}}</b></p>
                    <p>Retirement age: <b>{{client.retirementAge}}</b></p>
                    <p *ngIf="clientHealthConditions && clientHealthConditions.length">Health conditions: 
                        <b *ngIf="clientHealthConditions && clientHealthConditions.length > 1">Multiple Conditions</b>
                        <b *ngIf="clientHealthConditions && clientHealthConditions.length == 1">{{formatCondition(clientHealthConditions[0])}}</b>
                    </p>
                </div>
            </div>
        </div>

        <div class="section" *ngIf="isFamilyVisible">
            <div class="section-header">
                <img alt="My family" class="page-icon" src="../../../assets/icons/household.svg" />
                <span>My family</span>
                <span class="edit-icon" (click)="directUserToForm('my-family')" (keyup.enter)="directUserToForm('my-family')" tabindex=0>
                    <mat-icon>edit</mat-icon>
                </span>
            </div>
            <div class="section-content">
                <p *ngIf="isSpouseVisible"><b>Spouse</b></p>
                <div *ngIf="isSpouseVisible">
                    <span id="spouse-age">Age: <b>{{spouse.currentAge}}</b></span>
                    <span id="spouse-gender">Sex: <b>{{formatGender(spouseGenderStr)}}</b></span>
                </div>
                <div>
                    <p *ngIf="isSpouseVisible">Retirement age: <b>{{spouse.retirementAge}}</b></p>
                    <p *ngIf="isSpouseVisible && spouse.healthConditions">Health conditions:
                        <b *ngIf="isSpouseVisible && spouse.healthConditions && spouse.healthConditions.length > 1">Multiple Conditions</b>
                        <b *ngIf="isSpouseVisible && spouse.healthConditions && spouse.healthConditions.length == 1">{{formatCondition(spouse.healthConditions[0])}}</b>
                    </p>
                    <div *ngIf="isDependentsVisible">
                        <p>Dependents: <b>Ages <span style="margin: 0 5px 0 0" *ngFor="let dependent of this.family.dependents; let idx = index;">{{dependent.age}}{{ (idx == this.family.dependents.length - 1 || this.family.dependents.length == 1) ? '' : ','}}</span></b></p>
                    </div>
                </div>
            </div>
        </div>

        <div class="section" *ngIf="isHealthcareCostsVisible">
            <div class="section-header">
                <img alt="Healthcare costs" class="page-icon" src="../../../assets/icons/healthcare costs.svg" />
                <span>Healthcare costs</span>
                <span class="edit-icon" (click)="directUserToForm('pre-retirement-costs')" (keyup.enter)="directUserToForm('pre-retirement-costs')" tabindex=0>
                    <mat-icon>edit</mat-icon>
                </span>
            </div>
            <div class="section-content">
                <div>
                    <p>For {{requestObject.planForYear}}:
                        <b>{{ outOfPocket | currency : 'USD' : 'symbol' : '1.0-0'}}</b></p>
                    <p *ngIf="isRetirementYearOneVisible">Retirement year 1: <b>{{yearOneRetirement}}</b>&nbsp;(in today's dollars)</p>
                </div>
            </div>
        </div>

        <div class="section" *ngIf="isHSABalanceVisible">
            <div class="section-header">
                <img alt="HSA information" class="page-icon" src="../../../assets/icons/Icon material-account-balance.svg" />
                <span>HSA information</span>
                <span class="edit-icon" (click)="directUserToForm('hsa-information')" (keyup.enter)="directUserToForm('hsa-information')" tabindex=0>
                    <mat-icon>edit</mat-icon>
                </span>
            </div>
            <div class="section-content">
                <div>
                    <p>Balance: <b>{{clientHSADetails.hsaBalance | currency : 'USD' : 'symbol' : '1.0-0'}}</b></p>
                </div>
            </div>
        </div>

        <div class="section" *ngIf="isHSAInvestmentVisible">
            <div class="section-header">
                <img alt="HSA investment" class="page-icon" src="../../../assets/icons/Icon open-graph.svg" />
                <span>HSA investment</span>
                <span class="edit-icon" (click)="directUserToForm('hsa-investment')" (keyup.enter)="directUserToForm('hsa-investment')" tabindex=0>
                    <mat-icon>edit</mat-icon>
                </span>
            </div>
            <div class="section-content">
                <div>
                    <p>Pre-retirement: <b>{{clientHSADetails.preRetirementInvestment}}%</b></p>
                    <p>In-retirement: <b>{{clientHSADetails.retirementInvestment}}%</b></p>
                    <p>Tax bracket: <b>{{this.taxPercentage | number: '1.0-0'}}%</b></p>
                </div>
                <p class="disclaimer">** Tax bracket of {{taxPercentage | number: '1.0-0'}}% determined by marital status and income used to calculate
                        savings</p>
            </div>
        </div>
        <!-- <div class="sidebar-footer" *ngIf="isHSAInvestmentVisible">
            <div class="button-container">
                <button class="button filled-button" (click)="getReport()" (keyup.enter)="getReport()" tabindex=0>GET MY REPORT</button>
            </div>
        </div> -->
    </div>
</div>